export enum QUALITY_INDEX_STATUS {
  GOOD = "good",
  WARNING = "warning",
  BAD = "bad",
}

export enum ENERGY_LEVEL {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export enum QUALITY_INDEX_MODE {
  NO = "no",
  DIGITAL = "digital",
  ANALOG = "analog",
}

export class QualityIndexLog {
  public id: number = 0;
  public channelId: number = 0;
  public date: Date = new Date();
  public status: QUALITY_INDEX_STATUS = QUALITY_INDEX_STATUS.GOOD; // 'good' / 'warning' / 'bad'
  public watermarkEnergy: ENERGY_LEVEL = ENERGY_LEVEL.HIGH; // 'high' / 'medium' / 'low'
  public signalEnergy: ENERGY_LEVEL = ENERGY_LEVEL.HIGH; // 'high' / 'medium' / 'low'
  public resampling: number = 0; ///< Detected resampling // pace
  public notWatermarkedAudio: boolean = false; ///< Presence of not Watermarked audio
  public discontinuity: boolean = false; ///< Presence of audio discontinuity
}
